module.exports = __webpack_public_path__ + "static/media/19ESCAP9.f517d6bc.jpg";